import Button from "@material-ui/core/Button";
import GlobalStyles from "../GlobalStyles";
import SvgIcon from "@material-ui/core/SvgIcon";
import {Download as DownloadIcon} from "react-feather";
import React from "react";
import {useTranslation} from "react-i18next";

export const ExportButton = ({onClick}) => {

	const { t } = useTranslation();
    return (<Button className={GlobalStyles.filterActionButton} onClick={onClick}
                    startIcon={
                      <SvgIcon fontSize="small">
                        <DownloadIcon />
                      </SvgIcon>
                    }
                  >
                      {t('Export')}
                </Button>
);
}